import { useFetchPartialRating } from './use-fetch-partial-rating.hook';

import { Appointment } from '@/types/appointments.types';

export const useAppointmentReviewStatus = (appointment: Appointment) => {
  const isReviewable = appointment.hasFinished && appointment.rateable;
  const { isLoading: isLoadingPartialReview, rating } = useFetchPartialRating(appointment.id, isReviewable);

  const isVisibleExpiredReviewBanner = appointment.hasFinished
    ? !appointment.rateable && new Date() > new Date(appointment.rateableUntil)
    : false;

  const isVisiblePendingReviewBanner = appointment.hasFinished
    ? !appointment.rateable && new Date() <= new Date(appointment.rateableUntil)
    : false;

  const isAppointmentRatable = isReviewable && !rating;

  return {
    isVisibleExpiredReviewBanner,
    isVisiblePendingReviewBanner,
    isAppointmentRatable,
    isLoadingPartialReview,
    rating,
  };
};
